import { Component, Input, Output, ContentChild, ContentChildren, QueryList, TemplateRef, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { UserContextService } from '../../../services/service/user-context.service';
import { ListView } from '../../model/list-view';

@Component({
    selector: 'zx-list-view',
    templateUrl: './list-view.component.html',
    styleUrls: ['./list-view.component.css'],
})
export class ListViewComponent implements OnInit {

    private delayingLoad;
    private _listView: ListView = new ListView();

    @Output() loadData: EventEmitter<any> = new EventEmitter();

    @ContentChild('dataTable', {static:true}) tpl_dataTable: TemplateRef<void>;
    @ContentChild('headRow', {static:true}) tpl_headRow: TemplateRef<void>;
    @ContentChild('headColumn', {static:true}) tpl_headColumn: TemplateRef<void>;
    @ContentChild('headOperations', {static:true}) tpl_headOperations: TemplateRef<void>;
    @ContentChild('dataRow', {static:true}) tpl_dataRow: TemplateRef<void>;
    @ContentChild('dataColumn', {static:true}) tpl_dataColumn: TemplateRef<void>;
    @ContentChild('dataOperations', {static:true}) tpl_dataOperations: TemplateRef<void>;

    constructor(
        private router: Router,
        private userContext: UserContextService
    ) { }

    ngOnInit() {
    }


    @Input() set listView(listView: ListView) {
        if (this._listView == listView || listView == null) return;
        listView.sortChange.subscribe(() => this.query());
        listView.filterChange.subscribe(() => this.query());
        listView.queryChange.subscribe(() => this.query());
        listView.paginationChange.subscribe(() => this.query());
        this._listView = listView;
    }
    get listView(): ListView {
        return this._listView;
    }

    public sort(name: string, direct: string) {
        const sortValue = {};
        sortValue[name] = direct;
        this.listView.sortValue = sortValue;
        this.query();
    }
    public query(msg?: string) {
        if (this.delayingLoad) clearTimeout(this.delayingLoad);
        this.listView.showLoading = true;
        this.delayingLoad = setTimeout(() => {
            this.delayingLoad = null;
            this.loadData.emit(msg);
        }, 300);
    }
}